import { createApolloClient } from 'entoro-shared';
import { GRAPHQL_URI as uri } from '../config';

const apolloClient = createApolloClient({ uri });

export default apolloClient;



// WEBPACK FOOTER //
// ./src/apollo/client.js